/**
 * TC Document Type Service — manages document type catalog and service-doc requirements
 */

import ApiService from './api.service';

const getTypingCenterId = () => {
  return (
    localStorage.getItem('typingCenterId') ||
    JSON.parse(localStorage.getItem('currentUser') || '{}')?.typingCenterId
  );
};

const tcDocumentTypeService = {
  getAll: async (holderType) => {
    const typingCenterId = getTypingCenterId();
    const response = await ApiService.get('/api/tc-document-types', {
      params: { typingCenterId, ...(holderType ? { holder_type: holderType } : {}) }
    });
    return response?.data?.data || [];
  },

  getActive: async (holderType) => {
    const typingCenterId = getTypingCenterId();
    const response = await ApiService.get('/api/tc-document-types/active', {
      params: { typingCenterId, ...(holderType ? { holder_type: holderType } : {}) }
    });
    return response?.data?.data || [];
  },

  create: async (data) => {
    const typingCenterId = getTypingCenterId();
    const response = await ApiService.post('/api/tc-document-types', { typingCenterId, ...data });
    return response?.data?.data || response?.data;
  },

  update: async (id, data) => {
    const response = await ApiService.put(`/api/tc-document-types/${id}`, data);
    return response?.data?.data || response?.data;
  },

  seedDefaults: async () => {
    const typingCenterId = getTypingCenterId();
    const response = await ApiService.post('/api/tc-document-types/seed', { typingCenterId });
    return response?.data?.data || response?.data;
  },

  // Service document requirements
  getRequirements: async (serviceId) => {
    const response = await ApiService.get(`/api/internal-services/${serviceId}/document-requirements`);
    return response?.data?.data || [];
  },

  saveRequirements: async (serviceId, requirements) => {
    const response = await ApiService.put(`/api/internal-services/${serviceId}/document-requirements`, { requirements });
    return response?.data?.data || [];
  }
};

export default tcDocumentTypeService;
